var _style, _path, _path2, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSingles(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 36 36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.2;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_21_",
    className: "st0",
    d: "M18,2c-0.5,0-1,0.2-1.5,0.4C17.4,2.9,18,3.8,18,4.9s-0.6,2-1.5,2.5C17,7.6,17.5,7.8,18,7.8 c1.6,0,2.9-1.3,2.9-2.9S19.6,2,18,2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_20_",
    className: "st0",
    d: "M18,12.2c-0.5,0-1,0.1-1.5,0.2c2.5,0.7,4.4,2.9,4.4,5.6v5.1c0,0.4-0.3,0.7-0.7,0.7h-0.7 c-0.8,0-1.5,0.7-1.5,1.5v8c0,0.4-0.3,0.7-0.7,0.7h2.9c0.4,0,0.7-0.3,0.7-0.7v-8c0-0.8,0.7-1.5,1.5-1.5h0.7c0.4,0,0.7-0.3,0.7-0.7V18 C23.8,14.8,21.2,12.2,18,12.2z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_13_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_17_",
    d: "M18,9.3c2.4,0,4.4-2,4.4-4.4s-2-4.4-4.4-4.4s-4.4,2-4.4,4.4S15.6,9.3,18,9.3z M18,2c1.6,0,2.9,1.3,2.9,2.9 S19.6,7.8,18,7.8s-2.9-1.3-2.9-2.9S16.4,2,18,2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_14_",
    d: "M18,10.7c-4,0-7.3,3.3-7.3,7.3v5.1c0,1.2,1,2.2,2.2,2.2h0.7v8c0,1.2,1,2.2,2.2,2.2h4.4c1.2,0,2.2-1,2.2-2.2 v-8h0.7c1.2,0,2.2-1,2.2-2.2V18C25.3,14,22,10.7,18,10.7z M23.8,23.1c0,0.4-0.3,0.7-0.7,0.7h-0.7c-0.8,0-1.5,0.7-1.5,1.5v8 c0,0.4-0.3,0.7-0.7,0.7h-4.4c-0.4,0-0.7-0.3-0.7-0.7v-8c0-0.8-0.7-1.5-1.5-1.5h-0.7c-0.4,0-0.7-0.3-0.7-0.7V18 c0-3.2,2.6-5.8,5.8-5.8s5.8,2.6,5.8,5.8V23.1z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSingles);
export default __webpack_public_path__ + "static/media/icon-singles.6d0158888d3685674633f8909cb2fbfd.svg";
export { ForwardRef as ReactComponent };